import { type Attendee } from 'hb-react/shared/apps/Events';
import { useForm } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/hooks/useForm';

export const useAttendeeSync = () => {
  const { values, errors, setFieldValue } = useForm();

  const syncAttendeeField = (fieldName: keyof Attendee, index: number) => {
    const sourceAttendee = values.attendees[index];

    if (errors.attendees?.[index]?.[fieldName] || !sourceAttendee) {
      return;
    }

    const otherAttendees = values.attendees
      .map((attendee, i) => [attendee, i] as const)
      .filter(
        ([attendee, i]) =>
          i !== index && attendee.guest_id === sourceAttendee.guest_id,
      );

    if (otherAttendees.length === 0) {
      return;
    }

    const sourceValue = sourceAttendee[fieldName];

    otherAttendees.forEach(([attendee, targetIndex]) => {
      const targetValue = attendee[fieldName];

      if (sourceValue !== targetValue) {
        setFieldValue(
          `attendees[${targetIndex}].${fieldName}`,
          sourceValue,
          false,
        );
      }
    });
  };

  return { syncAttendeeField };
};
